import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { SupporterVoicesConfig } from '../supporterVoicesConfig/types';

import {
	GammaPetitionPageVideos,
	type GammaPetitionPageVideosQuery as PetitionPageVideosQuery,
	type GammaPetitionPageVideosQueryVariables as PetitionPageVideosQueryVariables,
} from './api.graphql';

export type SupporterVoicesData = {
	supporterVoicesEnabled: boolean;
	// FIXME simplify into videos: PetitionPageVideosQuery['petitionVideosConnection']['nodes']
	videos?:
		| {
				getPetitionVideos: {
					petitionVideos: PetitionPageVideosQuery['petitionVideosConnection']['nodes'];
				};
		  }
		| null
		| undefined;
	openVideoCreationFromPetitionDetails?: boolean;
};

export const getSupporterVoices = async (
	utilityContext: UtilityContext,
	slugOrId: string,
	supporterVoicesConfig: SupporterVoicesConfig,
	disableDisplay?: boolean | null,
): Promise<SupporterVoicesData> => {
	/**
	 * The supporter_voices_petition_details FCM is fetched first and if the feature should be
	 * disabled for the user, the fetch for the supporter videos is not called.
	 */
	if (!supporterVoicesConfig.supporterVoicesEnabled || disableDisplay) {
		return {
			supporterVoicesEnabled: false,
		};
	}

	const { sortByScoreEnabled } = supporterVoicesConfig;

	const { data: videos } = await utilityContext.gql.fetch<PetitionPageVideosQuery, PetitionPageVideosQueryVariables>({
		query: GammaPetitionPageVideos,
		variables: {
			petitionSlugOrId: slugOrId,
			first: 10,
			sortBy: sortByScoreEnabled ? 'SCORE' : 'VOTING_SCORE',
		},
		rejectOnError: false,
		batched: false,
	});

	return {
		videos: videos
			? {
					getPetitionVideos: {
						petitionVideos: videos.petitionVideosConnection.nodes,
					},
				}
			: null,
		...supporterVoicesConfig,
	};
};
